import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/roadmap.css';
import Bubble from '../components/Bubble';

const Roadmap = () => {
  const { t } = useTranslation();

  return (
    <div className="roadmap-page">
      <h1 className="roadmap-title">{t('roadmap.page.title')}</h1>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '25px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 1: Visión */}
          <Bubble 
            className="bubble-1"
            title={t('roadmap.vision.title')}
            content={t('roadmap.vision.content')}
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 2: Fase 1 */}
          <Bubble 
            className="bubble-2"
            title={t('roadmap.phase1.title')}
            content={
              <ul>
                {t('roadmap.phase1.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        <div style={{ marginTop: '60px' }}></div>
        
        {/* Segunda fila: Fase 2 y 3 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 3: Fase 2 */}
          <Bubble 
            className="bubble-3"
            title={t('roadmap.phase2.title')}
            content={
              <ul>
                {t('roadmap.phase2.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="purple"
            position="center"
            size="medium"
          />

          {/* Burbuja 4: Fase 3 */}
          <Bubble 
            className="bubble-4"
            title={t('roadmap.phase3.title')}
            content={
              <ul>
                {t('roadmap.phase3.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="orange"
            position="center"
            size="medium"
          />
        </div>

        <div style={{ marginTop: '60px' }}></div>

        {/* Tercera fila: Fase 4 (centrada) */}
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 5: Fase 4 */}
          <Bubble 
            className="bubble-5"
            title={t('roadmap.phase4.title')}
            content={
              <ul>
                {t('roadmap.phase4.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="blue"
            position="center"
            size="medium"
          />
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
